import VueRouter from 'vue-router';

import { APP_BASE_URL } from '@config/info';
import OldInncashLayout from '@oldinncash/views/app/app.vue';

import NewInncashLayout from '@/components/navigation/NewInncashLayout.vue';

import { moduleGuard, redirectAuthGuard } from '@/router/guards/RouteGuards';

import AppView from '@/components/navigation/AppView.vue';
import Login from '@/views/login/Login.vue';
import TokenHandler from '@/views/tokenHandler/TokenHandler.vue';
import ForgotPassword from '@/views/passwordManagament/ForgotPassword.vue';
import ResetPassword from '@/views/passwordManagament/ResetPassword.vue';
import ContactSupport from '@/views/contactSupport/ContactSupport.vue';

import oldInncashRoutes from './old_inncash.routes';
import newInncashRoutes from './new_inncash.routes';

const routes = [
	{
		path: '/',
		component: AppView,
		children: [
			{
				path: '/',
				name: 'home',
				component: OldInncashLayout,
				children: oldInncashRoutes,
			},
			{
				path: '/',
				name: 'new',
				component: NewInncashLayout,
				children: newInncashRoutes,
			},
		],
		beforeEnter: moduleGuard,
	},
	{ path: '/esqueci-minha-senha', name: 'ForgotPassword', component: ForgotPassword },
	{ path: '/redefinir-senha/:token', name: 'ResetPasswordToken', component: ResetPassword },
	{ path: '/redefinir-senha', name: 'ResetPassword', component: ResetPassword },
	{ path: '/entre-em-contato', name: 'ContactSupport', component: ContactSupport },
	{ path: '/login', name: 'login', component: Login },
	{ path: '/logintoken/:auto/:thirdtoken', name: 'logintoken', component: Login },
	{ path: '/:token', name: 'TokenHandler', component: TokenHandler },
];

const router = new VueRouter({
	mode: 'history',
	base: APP_BASE_URL,
	routes,
});

function removeHubSpotCompletely() {
	const w = window;

	if (w.HubSpotConversations) {
		try {
			w.HubSpotConversations.widget.close();
			w.HubSpotConversations.widget.remove();
			w.HubSpotConversations.clear({ resetWidget: true });
		} catch (e) {
			console.log('HubSpot cleanup error:', e);
		}
	}

	// 2. Remove o script
	const script = document.getElementById('hs-script-loader');
	if (script) {
		script.remove();
	}

	// 3. Limpa as configurações globais
	w.hsConversationsSettings = undefined;
	w.hsConversationsOnReady = undefined;

	// 4. Remove TODOS os elementos do HubSpot do DOM
	const selectors = [
		'[id^="hubspot"]',
		'[class*="hs-"]',
		'iframe[src*="hubspot"]',
		'iframe[src*="hs-scripts"]',
		'iframe[src*="hs-banner"]',
		'#hs-web-interactives-top-anchor',
		'#hs-web-interactives-bottom-anchor',
		'[id^="hs-"]',
		'[data-hubspot-wrapper]',
	];

	const hubspotElements = document.querySelectorAll(selectors.join(', '));
	hubspotElements.forEach((el) => el.remove());

	delete w.HubSpotConversations;
}

router.beforeEach((to, from, next) => {
	const hiddenRoutes = [
		'/login',
		'/esqueci-minha-senha',
		'/redefinir-senha',
		'/entre-em-contato',
	];

	const isHiddenRoute = hiddenRoutes.some((path) => to.path.startsWith(path));

	if (isHiddenRoute) {
		removeHubSpotCompletely();
	}

	next();
});

router.beforeEach(redirectAuthGuard);

export default router;
